



















































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import OrderAPI from '@/services/OrderAPI';

import Order from '@/types/Order';

export default Vue.extend({
    name: 'OrderItemList',

    props: {
        order: Object as () => Order,
        readonly: Boolean,
        isBoxed: {
            type: Boolean,
            default: true
        }
    },

    computed: {
		...mapState(['language']),

        ...mapGetters(['getCurrencySymbol', 'getLanguage', 'isUserAdmin'])
    },

    methods: {
        changeNumberItem(orderId: string, itemId: string, add: boolean) {
            const handleResponse = (response: AxiosResponse) => {
                        if (response.data) {
                            this.$store.commit('setOrder', response.data);
                        }
                    };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        return;
                    }
                };

            if (add) {
                OrderAPI
                    .putItem(orderId, itemId)
                    .then(handleResponse)
                    .catch(handleError);
            } else {
                OrderAPI
                    .deleteItem(orderId, itemId)
                    .then(handleResponse)
                    .catch(handleError);
            }
        },

        showItem(itemId: string): void {
            this.$router.push(`/${this.language}/admin/items/${itemId}`);
        }
    }
});
